(function () {
  'use strict';

  /* @ngdoc object
   * @name exports.edit
   * @description
   *
   */
  angular
    .module('plantProtection.exports.edit', [
      'ui.router'
    ]);
}());
